// Path: src/utilities/getTextNodeFromPoint.js

const getTextNodeFromPoint = (clientX, clientY) => {
  let range;
  let textNode = null;
  if (document.caretPositionFromPoint) {
    range = document.caretPositionFromPoint(clientX, clientY);
    textNode = range?.offsetNode;
  } else if (document.caretRangeFromPoint) {
    // Use WebKit-proprietary fallback method
    range = document.caretRangeFromPoint(clientX, clientY);
    textNode = range?.startContainer;
  }
  return textNode;
};

export default getTextNodeFromPoint;
